document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('case-filter')
  const selects = form.querySelectorAll('select')
  let debounceTimer

  // フィルター変更時の処理
  selects.forEach(select => {
    select.addEventListener('change', function() {
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => {
        const formData = new FormData(form)
        const queryString = new URLSearchParams(formData).toString()
        const currentPath = window.location.pathname
        window.location.href = `${currentPath}?${queryString}`
      }, 300)
    })
  })
})
